import AppModal from "@/components/AppModal";
import AppLoadingButton from "@/components/mui/LoadingButton";
import RpIcon from "@/components/RpIcon";
import API from "@/constant/API";
import { VerifyAction } from "@/constant/VerifyConstant";
import useToggle from "@/hook/useToggle";
import classes from "@/pages/security/css/index.module.less";
import { getTaskId, onUserLogout, setTaskRuleParams } from "@/redux/slices/user";
import { dispatch } from "@/redux/store";
import axiosInstance from "@/utils/axios";
import { Box, Stack } from "@mui/material";
import { useConfirm } from "material-ui-confirm";
import { enqueueSnackbar } from "notistack";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import SimpleHeader from "../components/Headers/SimpleHeader";
import Security2FA from "./Security2FA";
import {useNavigate} from "react-router-dom";
import RouteConstant from "@/constant/RouteConstant";

function AccountDelete() {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const {user,homeInfo} = useSelector((state) => state.user);
  const confirm = useConfirm();
  const navigate = useNavigate();
  const {
    toggle: show2FA,
    onToggle: onToggleShow2FA,
  } = useToggle(false);

  const _onDelete = () => {
    confirm({
      title: t('warning'),
      description: t('account_deletion_regret_promp'),
      confirmationText: t('confirm'),
      cancellationText: t('cancel'),
    }).then(() => {
      setTaskRuleParams({
        action: VerifyAction.DELETE_ACCOUNT,
      })
      onToggleShow2FA();
    });
  }

  const _doDelete = async () => {
    setLoading(true);
    try {
      await axiosInstance.post(API.DELETE_ACCOUNT, {
        taskId: getTaskId(),
      });
      // TODO: 提醒用户删除用户成功
      enqueueSnackbar(t('account_deletion_successful'), { variant: 'error' })
      // 登出用户
      dispatch(onUserLogout(RouteConstant.WELCOME));
      // navigate(RouteConstant.WELCOME, {replace: true})
    }catch(error){
      console.log("账号注销失败",error)
    } finally {
      setLoading(false);
    }
  }

  return (<>

    <Box>
      <SimpleHeader />
      <Box className={classes["security-wrap"]}>
        <Box className={classes["security-title-wrap"]}>
          <div className={classes["security-title"]}>{t('delete_account')}</div>
        </Box>
        <Box>
          <ul className={classes["delete-prompt"]}>
            <li>
              <p className={classes["delete-prompt-primary"]}>{t('account_deletion_prompt_1')}</p>
              <p className={classes["delete-prompt-warm"]}>{user?.mobile}/{user?.email}</p>
            </li>
            <li>{t('account_deletion_prompt_2')}</li>
            <li>{t('account_deletion_prompt_3')}</li>
            <li>{t('account_deletion_prompt_4')}</li>
            <li>{t('account_deletion_prompt_5')}</li>
            <li>{t('account_deletion_prompt_6')}</li>
            <li>{t('account_deletion_prompt_7')}</li>
          </ul>
        </Box>
        <Stack className={classes["delete-prompt-agreement"]} direction={'column'} gap={'24px'}>
          <Stack direction={'row'} alignItems={'center'} gap={'6px'}>
            <RpIcon icon="checkbox-checked" size={16}/>
            <p>{t('abandon_assets', { amount: homeInfo?.assetUser?.balance, currency:homeInfo?.assetUser?.currencyCode })}</p>
          </Stack>
          <Stack direction={'row'} alignItems={'center'} gap={'6px'}>
            <RpIcon icon="checkbox-checked" size={16}/>
            <p>{t('accounts_are_not_available')}</p>
          </Stack>
        </Stack>
        <Box className={classes["fixed-button"]}>
          <AppLoadingButton
            fullWidth
            loading={loading}
            variant="contained"
            color="error"
            size="large"
            onClick={_onDelete}
          >
            {t('delete_account')}
          </AppLoadingButton>
        </Box>
      </Box>
      <AppModal open={show2FA} onClose={onToggleShow2FA}>
        <Security2FA callback={_doDelete} onClose={onToggleShow2FA}/>
      </AppModal> 
    </Box>
  </>);
}

export default AccountDelete;
